// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__R3qgq","additionalInfo":"AgreementModal_additionalInfo__3efXP"};